
















































































































import Vue from 'vue';
// import favorite from '@/modules/analysis/favorite';
import {
  // firebase,
  calender,
  // exhibitor as exhibitorM,
  // Exhibitor,
  // buyer as buyerM,
  // Buyer,
  // brand as brandM,
  // buyerCompany,
  // BuyerCompany,
  contact,
  ContactListItem,
} from 'mostra';

// import { collectionNames, FirebaseID } from '@/modules/firestore';
// import { assignWithIdT } from '@/modules/tools';
// import contact, { ContactListItem } from '@/modules/contact/contact';
// import brandM from '@/modules/exhibitor/brand';
import messageM from '@/modules/contact/message';
// import bCompanyM, { Company as BCompany } from '@/modules/buyer/company';
// import eCompanyM, { Company as ECompany } from '@/modules/exhibitor/company';
// import exhibitorM, { Exhibitor } from '@/modules/exhibitor/exhibitor';
// import buyerM, { Buyer } from '@/modules/buyer/buyer';

export type DataType = {
  contactList: ContactListItem[];
  currentPage: number;
  perPage: number;
  loading: boolean;
  isForced: boolean;
  total: number;
};

export default Vue.extend({
  name: 'admin-admin-analysis-contact-index',
  data(): DataType {
    return {
      contactList: [],
      currentPage: 1,
      perPage: 30,
      loading: true,
      isForced: false,
      total: 0,
    };
  },
  computed: {
    isFirstPage(): boolean {
      return this.currentPage === 1;
    },
  },
  watch: {
    async isForced(val: boolean) {
      this.$loading(true);
      try {
        this.contactList = await contact.loadContactList(this.perPage, 1, val);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = 1;
        this.$loading(false);
      }
    },
  },
  methods: {
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    latestMessage(messages: any[]) {
      const m = messages[messages.length - 1];
      return m || { id: null, data: {} };
    },
    typeStr(t: number) {
      return messageM.typeOfString(t);
    },
    async onChangePage(targetPage: number) {
      this.$loading(true);
      try {
        this.contactList = await contact.loadContactList(this.perPage, targetPage, this.isForced);
        // console.log(this.contactList);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = targetPage;
        this.$loading(false);
      }
    },
    async onClickCountAllContacts() {
      this.total = await contact.countAllContacts();
    },
  },
  async mounted() {
    this.loading = true;
    this.$loading(true);
    try {
      this.contactList = await contact.loadContactList(this.perPage, 1);
      // console.log(this.contactList);
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.loading = false;
      this.$loading(false);
    }
  },
});
